import dateFormat from 'dateformat';
import { getQuarter } from 'pages/BudgetPlanner/context/createBudgetConfigData';
import { BudgetPeriod } from 'store/budget/interfaces';
import { Transaction } from 'store/transactions/transactions';

export default function getPeriodByBudgetPeriodType(transaction: Transaction, budgetPeriod: string) {
    const transactionDate = transaction.connectedMonth ?? transaction.orderDate;

    if (budgetPeriod === BudgetPeriod.quarter) {
        return getQuarter(new Date(transactionDate))
    }

    return dateFormat(transactionDate, 'yyyymm');
}
